const currencyFormat = (num) => {
    let numString = num.toString();

    // Split the number in integer and decimal parts
    let parts = numString.split(".");
    let integerPart = parts[0].replace(/\./g, "");
    let decimalPart = parts.length > 1
        ? "," + parts[1].slice(0, 2) // Only take the first 2 decimal places
        : "";

    // Format only the integer part
    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

    // Join the parts
    return integerPart + decimalPart;
}

export { currencyFormat };